export default "__VITE_ASSET__pCRkk4F6__"